export const Facebook = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_7059_93198)">
        <path
          d="M20 10.061C20 4.50354 15.5225 -0.00146484 10 -0.00146484C4.475 -0.000214844 -0.00250244 4.50354 -0.00250244 10.0623C-0.00250244 15.0835 3.655 19.246 8.435 20.001V12.9698H5.8975V10.0623H8.4375V7.84354C8.4375 5.32229 9.93125 3.92979 12.215 3.92979C13.31 3.92979 14.4537 4.12604 14.4537 4.12604V6.60104H13.1925C11.9512 6.60104 11.5637 7.37729 11.5637 8.17354V10.061H14.3362L13.8937 12.9685H11.5625V19.9998C16.3425 19.2448 20 15.0823 20 10.061Z"
          fill="#232329"
        />
      </g>
      <defs>
        <clipPath id="clip0_7059_93198">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
